import _extends from "/home/runner/work/loan-application-form/loan-application-form/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/extends";
import _classCallCheck from "/home/runner/work/loan-application-form/loan-application-form/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/home/runner/work/loan-application-form/loan-application-form/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";
import _possibleConstructorReturn from "/home/runner/work/loan-application-form/loan-application-form/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/home/runner/work/loan-application-form/loan-application-form/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";
import _assertThisInitialized from "/home/runner/work/loan-application-form/loan-application-form/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/assertThisInitialized";
import _inherits from "/home/runner/work/loan-application-form/loan-application-form/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/inherits";
import _defineProperty from "/home/runner/work/loan-application-form/loan-application-form/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/defineProperty";
import React from 'react';
import { TextInput } from 'react-native';
export default (function (Navigator, navigatorConfig) {
  var _class, _temp;

  return _temp = _class =
  /*#__PURE__*/
  function (_React$Component) {
    _inherits(KeyboardAwareNavigator, _React$Component);

    function KeyboardAwareNavigator() {
      var _getPrototypeOf2;

      var _this;

      _classCallCheck(this, KeyboardAwareNavigator);

      for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
        args[_key] = arguments[_key];
      }

      _this = _possibleConstructorReturn(this, (_getPrototypeOf2 = _getPrototypeOf(KeyboardAwareNavigator)).call.apply(_getPrototypeOf2, [this].concat(args)));

      _defineProperty(_assertThisInitialized(_this), "_previouslyFocusedTextInput", null);

      _defineProperty(_assertThisInitialized(_this), "_handleGestureBegin", function () {
        _this._previouslyFocusedTextInput = TextInput.State.currentlyFocusedField();

        if (_this._previouslyFocusedTextInput) {
          TextInput.State.blurTextInput(_this._previouslyFocusedTextInput);
        }

        _this.props.onGestureBegin && _this.props.onGestureBegin();
      });

      _defineProperty(_assertThisInitialized(_this), "_handleGestureCanceled", function () {
        if (_this._previouslyFocusedTextInput) {
          TextInput.State.focusTextInput(_this._previouslyFocusedTextInput);
        }

        _this.props.onGestureCanceled && _this.props.onGestureCanceled();
      });

      _defineProperty(_assertThisInitialized(_this), "_handleGestureEnd", function () {
        _this._previouslyFocusedTextInput = null;
        _this.props.onGestureFinish && _this.props.onGestureFinish();
      });

      _defineProperty(_assertThisInitialized(_this), "_handleTransitionStart", function (transitionProps, prevTransitionProps) {
        // TODO: We should not even have received the transition start event
        // in the case where the index did not change, I believe. We
        // should revisit this after 2.0 release.
        if (transitionProps.index !== prevTransitionProps.index) {
          var currentField = TextInput.State.currentlyFocusedField();

          if (currentField) {
            TextInput.State.blurTextInput(currentField);
          }
        }

        var onTransitionStart = _this.props.onTransitionStart || navigatorConfig.onTransitionStart;
        onTransitionStart && onTransitionStart(transitionProps, prevTransitionProps);
      });

      return _this;
    }

    _createClass(KeyboardAwareNavigator, [{
      key: "render",
      value: function render() {
        return React.createElement(Navigator, _extends({}, this.props, {
          onGestureBegin: this._handleGestureBegin,
          onGestureCanceled: this._handleGestureCanceled,
          onGestureEnd: this._handleGestureEnd,
          onTransitionStart: this._handleTransitionStart
        }));
      }
    }]);

    return KeyboardAwareNavigator;
  }(React.Component), _defineProperty(_class, "router", Navigator.router), _defineProperty(_class, "navigationOptions", Navigator.navigationOptions), _temp;
});